// extracted by mini-css-extract-plugin
export default {"wrapper":"avatar_wrapper__gb5ha"};